import React from 'react';
import { TFunction } from 'i18next';

import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import { INotificationCampaign } from '../../../../types/interfaces/notification-admin';
import { NOTIFICATION_CAMPAIGN_COLUMN_IDS } from './notificationCampaignsTableColumns';

function campaignKindLabel(t: TFunction, row: INotificationCampaign): string {
  const k = row.kind ?? 'template';
  return k === 'inline'
    ? t('adminDashboard.notifications.campaigns.kindInline')
    : t('adminDashboard.notifications.campaigns.kindTemplate');
}

export function getNotificationCampaignsCellReducers(
  t: TFunction,
  classes: { actions?: string },
  opts: { canEdit: boolean; canDelete: boolean },
  langLabel: (filterJson: INotificationCampaign['filterJson']) => string,
  onEdit: (row: INotificationCampaign) => void,
  onDelete: (row: INotificationCampaign) => void,
) {
  const base = [
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.STATUS,
      cellReducer: (row: INotificationCampaign) => <div>{row.status}</div>,
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.KIND,
      cellReducer: (row: INotificationCampaign) => (
        <div>{campaignKindLabel(t, row)}</div>
      ),
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.TEMPLATE_CODE,
      cellReducer: (row: INotificationCampaign) => (
        <div>
          {(row.kind ?? 'template') === 'inline'
            ? '—'
            : (row.templateCode ?? '—')}
        </div>
      ),
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.SCHEDULED_AT,
      cellReducer: (row: INotificationCampaign) => (
        <div>
          {row.scheduledAt ? new Date(row.scheduledAt).toLocaleString() : '—'}
        </div>
      ),
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.LANGUAGE,
      cellReducer: (row: INotificationCampaign) => (
        <div>{langLabel(row.filterJson)}</div>
      ),
    },
  ];
  if (opts.canEdit || opts.canDelete) {
    base.push({
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.ACTIONS,
      cellReducer: (row: INotificationCampaign) => (
        <div className={classes.actions}>
          {opts.canEdit && <EditActionButton onClick={() => onEdit(row)} />}
          {opts.canDelete && (
            <DeleteActionButton onClick={() => onDelete(row)} />
          )}
        </div>
      ),
    });
  }
  return base;
}
